import { render, staticRenderFns } from "./MainModeList.vue?vue&type=template&id=5229f15a"
import script from "./MainModeList.vue?vue&type=script&lang=js"
export * from "./MainModeList.vue?vue&type=script&lang=js"
import style0 from "./MainModeList.vue?vue&type=style&index=0&id=5229f15a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports